import { render, staticRenderFns } from "./SubsCreate.vue?vue&type=template&id=077c55e8&"
import script from "./SubsCreate.vue?vue&type=script&lang=js&"
export * from "./SubsCreate.vue?vue&type=script&lang=js&"
import style0 from "./SubsCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports